// Windows paste fix: xterm.js translates every Ctrl+letter into its C0
// control code (Ctrl+V → \x16 to the PTY) and preventDefaults the event, so
// the browser's native paste event — which the whole paste pipeline (text →
// bracketed paste, image → upload) hangs off — never fires on Windows.
// Combos matched here are handed back to the browser via
// attachCustomKeyEventHandler (return false = xterm ignores the key).
// macOS Cmd+V never reaches xterm's translation, hence the metaKey guard
// keeps it on its already-working native path.

export interface PasteKeyEventLike {
  key: string;
  ctrlKey: boolean;
  altKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
}

export function isPasteKeyEvent(ev: PasteKeyEventLike): boolean {
  // !altKey: AltGr on German keyboards reports ctrlKey+altKey — never touch it.
  if (ev.altKey || ev.metaKey) return false;
  if (ev.ctrlKey && ev.key.toLowerCase() === "v") return true;        // Strg+V / Strg+Shift+V
  if (ev.shiftKey && !ev.ctrlKey && ev.key === "Insert") return true; // Shift+Einfg
  return false;
}
